export enum TestType {
    USER = 'USER',
    GUEST = 'GUEST',
}
